import { useContext } from 'react'
import { AccountSettingsContext } from './AccountSettingsContext'

export function useAccountSettings() {
  const context = useContext(AccountSettingsContext)

  if (!context) {
    throw new Error('useAccountSettings must be used within AccountSettingsProvider')
  }

  return context
}
